import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";


export class SpaceMyAccount extends SpaceProto {

    constructor() {
        super(NavigationSectionType.MY_ACCOUNT)


        this.positions  = []
        this.title      = "My Account"

        this.defaultPosition    = NavigationButtonPosition.STATIC

    }

    get position(): NavigationButtonPosition {
        return NavigationButtonPosition.STATIC
    }

    get navigationStructureConfig() {
        return {
            id                  : this.id,
            icon                : "i5-nav-users",
            iconActive          : "i5-nav-users-solid",
            hint                : "My Account",
            type                : NavigationSectionType.MY_ACCOUNT,
            renderComponent     : Navigation_ButtonGenericDeprecated,
            position            : NavigationButtonPosition.BOTTOM
        }

    }



}
